var map = {
	"./fa-brands-400.woff2": 61,
	"./fa-duotone-900.woff2": 62,
	"./fa-light-300.woff2": 63,
	"./fa-regular-400.woff2": 64,
	"./fa-solid-900.woff2": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;